const FONT_FAMILY =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

export const Maintenance = () => (
  <div
    className="min-h-screen bg-[#f5f6f5] px-6 py-16 text-[#3e3e3e] antialiased max-[34rem]:px-4 max-[34rem]:py-8"
    style={{ fontFamily: FONT_FAMILY }}
  >
    <div className="mx-auto flex max-w-[41.25rem] animate-rise flex-col items-center gap-8 rounded-xl border border-[#e6e8e6] bg-white px-14 pt-14 pb-13 motion-reduce:animate-none max-[34rem]:px-6 max-[34rem]:py-10">
      <h1 className="m-0 text-center text-[28px] leading-8 font-bold tracking-[-0.5px] text-balance text-[#3e3e3e]">
        We are getting better for you
      </h1>
      <div className="flex max-w-[32rem] flex-col gap-3">
        <p className="m-0 text-center text-base leading-5 font-normal tracking-[-0.5px] text-[#6e6e6e]">
          We are currently performing scheduled maintenance to improve our
          services. We appreciate your patience and understanding.
        </p>
        <p className="m-0 text-center text-base leading-5 font-normal tracking-[-0.5px] text-[#6e6e6e]">
          Please check back soon.
        </p>
      </div>
    </div>
  </div>
);
